import clsx from "clsx";
import { type ClassNames, getDefaultClassNames } from "react-day-picker";

const defaultClassNames = getDefaultClassNames();

export const dayPickerClassNames: Partial<ClassNames> = {
  root: clsx(defaultClassNames.root, "tw-flex-1 tw-border-[#f1f1f1]"),
  button_previous: clsx(
    "tw-absolute tw-left-7 tw-top-4 tw-w-8 tw-border-0 tw-bg-[#f5f5f5]",
    "tw-transition-colors hover:tw-bg-[#e8e8e8] active:tw-bg-[#e8e8e8]",
  ),
  month_caption: clsx(
    "tw-border-b tw-border-[#f1f1f1] tw-py-5 tw-text-center tw-text-sm",
    "tw-font-medium tw-capitalize tw-text-[#0b2d2d]",
  ),
  button_next: clsx(
    "tw-absolute tw-right-7 tw-top-4 tw-w-8 tw-border-0 tw-bg-[#f5f5f5]",
    "tw-transition-colors hover:tw-bg-[#e8e8e8] active:tw-bg-[#e8e8e8]",
  ),
  chevron: clsx(defaultClassNames.chevron, "tw-w-4 tw-fill-brand-green"),
  months: "w-full",
  month_grid: "tw-w-full tw-my-5",
  weekdays: clsx(defaultClassNames.weekdays, "tw-mx-[15px] tw-mb-[15px] tw-flex tw-justify-around"),
  disabled: "tw-cursor-default !tw-text-[#b8b8c8] tw-pointer-events-none",
  weekday: clsx("tw-text-sm tw-font-medium tw-capitalize tw-text-[#0b2d2d]"),
  weeks: clsx(defaultClassNames.weeks, "tw-flex tw-flex-col tw-gap-[13px]"),
  week: clsx(defaultClassNames.week, "tw-mx-[15px] tw-flex tw-justify-around"),
  day: clsx(
    defaultClassNames.day,
    "tw-h-9 tw-w-9 tw-transition-colors hover:tw-bg-[#f1f1f1] active:tw-bg-[#f1f1f1]",
  ),
  day_button: clsx(defaultClassNames.day_button, "tw-h-[36px] tw-w-[36px]"),
  selected: "tw-bg-brand-green tw-text-white hover:tw-bg-brand-green active:tw-bg-brand-green",
  today: clsx(
    "tw-relative tw-font-bold tw-text-brand-green",
    "before:tw-absolute before:tw-h-1 before:tw-w-1 before:tw-rounded-full",
    "before:tw-bg-brand-green before:tw-content-['']",
    "before:tw-bottom-[5px] before:tw-left-4",
  ),
};
